import { render, staticRenderFns } from "./AffiliateForm.vue?vue&type=template&id=5e5c30fe&"
import script from "./AffiliateForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateForm.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports